<template>
  <div>
    <h1>Schedule</h1>
    <div class="row">
      <div v-if="isLoaded" class="col-md-4 col-sm-12">
        <div v-if="nextShift">
          <h3 style="margin-top: 0">Next Shift</h3>
          <h4>{{ formattedDay(nextShift.day) }} - {{ nextShift.start_time }}</h4>
          <p>{{ nextShift.venue.name }}</p>
          <p>{{ nextShift.venue.location }}</p>
          <p>Role: {{ nextShift.role }}</p>
          <p>Start: {{ nextShift.start_time }}<br> End Time: {{ nextShift.end_time }}</p>
          <h4>Team Leaders</h4>
          <div class="row">
            <div class="col-6" v-for="tl in nextShift.venue.teamLeaders">{{ tl.name }}</div>
          </div>
        </div>
        <hr/>
      </div>
      <div v-else class="col-md-6 col-sm-12">
        <h3>Loading Schedule...</h3>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="row">
          <div class="col">
            <b-form-group label="Date" label-for="date" style="margin-bottom:unset">
              <b-form-select id="date" v-model="selectedDay" :options="days" class="mb-3" />
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h2 v-if="selectedDay === '2026-07-17'">Friday 17 July 2026</h2>
            <h2 v-if="selectedDay === '2026-07-18'">Saturday 18 July 2026</h2>
            <h2 v-if="selectedDay === '2026-07-19'">Sunday 19 July 2026</h2>
            <h2 v-if="selectedDay === '2026-07-20'">Monday 20 July 2026</h2>
            <h2 v-if="selectedDay === '2026-07-21'">Tuesday 21 July 2026</h2>
            <h2 v-if="selectedDay === '2026-07-22'">Wednesday 22 July 2026</h2>
            <h2 v-if="selectedDay === '2026-07-23'">Thursday 23 July 2026</h2>
          </div>
        </div>
        <div v-for="shift in dayShifts">
          <div @click="selectShift(shift)" class="row shift">
            <div class="col">
              <p>
                {{ shift.start_time }} - {{ shift.end_time }}
                <br>
                {{ shift.venue.name }}
                <br>
                Location: {{ shift.venue.location }}
                <br>
                Role: {{ shift.role }}
              </p>
            </div>
          </div>
        </div>
        <div class="row" v-if="isLoaded && dayShifts.length === 0">
          <div class="col">
            <h3 v-if="selectedDay === '2026-07-17'">No shifts for Friday 17 July 2026</h3>
            <h3 v-if="selectedDay === '2026-07-18'">No shifts for Saturday 18 July 2026</h3>
            <h3 v-if="selectedDay === '2026-07-19'">No shifts for Sunday 19 July 2026</h3>
            <h3 v-if="selectedDay === '2026-07-20'">No shifts for Monday 20 July 2026</h3>
            <h3 v-if="selectedDay === '2026-07-21'">No shifts for Tuesday 21 July 2026</h3>
            <h3 v-if="selectedDay === '2026-07-22'">No shifts for Wednesday 22 July 2026</h3>
            <h3 v-if="selectedDay === '2026-07-23'">No shifts for Thursday 23 July 2026</h3>
          </div>
        </div>
        <b-modal id="shift-modal" ref="shiftModal" :title="selectedShift.venue.name">
          <h4>{{ formattedDay(selectedShift.day) }} {{ selectedShift.start_time }} - {{ selectedShift.end_time }}</h4>
          <p>Please be at the SV Office 30 minutes before to checkin</p>
          <h5>Team Leaders</h5>
          <div class="row">
            <span v-for="teamLeader in selectedShift.venue.teamLeaders" :key="teamLeader">
              <div class="col">
                {{ teamLeader.name }}
              </div>
            </span>
          </div>
          <div slot="modal-footer">
            <div class="footer-left">
            </div>
            <div class="footer-right">
              <b-button @click="closeModal" variant="secondary">Close</b-button>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
    <div style="width: 150px;"></div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { days } from '@/util/SelectLists'
  import moment from 'moment-timezone'
  import router from '@/router'
  export default {
    name: 'SvSchedule',
    data () {
      return {
        selectedDay: '2026-07-17',
        days: days,
        selectedShift: {
          id: 0,
          start_time: '00:00',
          end_time: '01:00',
          swappable: false,
          day: '2026-07-17',
          sv_slots: 1,
          special: '',
          venue: {
            name: '',
            location: '',
            teamLeaders: []
          }
        }
      }
    },
    methods: {
      formattedDay: function (day) {
        return moment(day).utc().format('ddd MMM Do')
        // if (day.length === 10) {
        // } else {
          // return moment(day).utc().format('ddd MMM Do')
        // }
      },
      selectShift: function (shift) {
        this.selectedShift = shift
        this.$refs.shiftModal.show()
      },
      swapShift: function () {
        router.push({ name: 'CreateShiftSwapRequest', params: { id: this.selectedShift.id } })
      },
      closeModal: function () {
        this.selectedShift = {
          start_time: '00:00',
          end_time: '01:00',
          swappable: false,
          day: '2026-07-17',
          sv_slots: 1,
          special: '',
          venue: {
            name: '',
            location: '',
            teamLeaders: []
          }
        }
        this.$refs.shiftModal.hide()
      },
      goToShiftSwapRequests: function () {
        router.push('/schedule/swap/list')
      }
    },
    computed: {
      ...mapState('schedule', ['shifts', 'isLoaded']),
      ...mapGetters('schedule', ['nextShift']),
      ...mapGetters(['isError', 'isMessage']),
      dayShifts: function () {
        return this.shifts.filter(shift => {
          return this.selectedDay === moment(shift.day).utc().format('Y-MM-DD')
        })
      }
    },
    created () {
      if (!this.$store.state.schedule.isLoaded) {
        this.$store.dispatch('schedule/load')
      }
      if (moment(this.selectedDay).isBefore(moment(), 'day')) {
        if (moment().isAfter(moment(this.days[this.days.length - 1].value))) {
          this.selectedDay = this.days[this.days.length - 1]
          console.log(this.selectedDay)
          console.log('if')
        } else {
          this.selectedDay = moment().utc().format('Y-MM-DD')
          console.log(this.selectedDay)
          console.log('else')
        }
      }
    }
  }
</script>

<style lang="scss">
.shift {
  background-color: #007cb5;
  color: #ffffff;
  padding: 15px 0px;
  margin: 10px 0px;
  cursor: pointer;
}
.modal-footer {
  display: block !important;
  .footer-left {
    text-align: left;
    display: inline-block;
  }
  .footer-right {
    text-align: right;
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/schedule/SvSchedule.vue